export const infoTag = "<info>";
